import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";
import { withTrackEvent } from "@newsela/snitch";
import RawCheckIcon from "@/icons/CheckIcon/RawCheckIcon.svg.jsx";
import RawCloseIcon from "@/icons/CloseIcon/RawCloseIcon.svg.jsx";
import RawEditIcon from "@/icons/EditIcon/RawEditIcon.svg.jsx";
import { textCss } from "./ParentTeacherWritePromptActions.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const EditButton = (props) => {
  return (
    <ButtonWithTrackEvent
      flavor={Button.flavors.tertiary}
      size={Button.sizes.sm}
      icon={{
        SvgComponent: RawEditIcon,
        alignment: Button.iconAlignments.left,
      }}
      __cssFor={{ root: textCss, Icon: { root: { path: { strokeWidth: 2 } } } }}
      dataProps={{ "data-qa-selector": "edit_write_prompt" }}
      streamProperties={{
        description: "Edit write prompt",
      }}
      {...props}
    >
      Edit
    </ButtonWithTrackEvent>
  );
};

const CancelButton = (props) => {
  return (
    <ButtonWithTrackEvent
      flavor={Button.flavors.tertiary}
      size={Button.sizes.sm}
      icon={{
        SvgComponent: RawCloseIcon,
        alignment: Button.iconAlignments.left,
      }}
      __cssFor={{ root: textCss, Icon: { root: { path: { strokeWidth: 4 } } } }}
      dataProps={{ "data-qa-selector": "cancel_edit_write_prompt" }}
      streamProperties={{
        description: "Cancel edit write prompt",
      }}
      {...props}
    >
      Cancel
    </ButtonWithTrackEvent>
  );
};

const SaveButton = (props) => {
  return (
    <ButtonWithTrackEvent
      flavor={Button.flavors.tertiary}
      size={Button.sizes.sm}
      icon={{
        SvgComponent: RawCheckIcon,
        alignment: Button.iconAlignments.left,
      }}
      __cssFor={{ root: textCss, Icon: { root: { path: { strokeWidth: 3 } } } }}
      dataProps={{ "data-qa-selector": "save_write_prompt" }}
      streamProperties={{
        description: "Save write prompt",
      }}
      {...props}
    >
      Save
    </ButtonWithTrackEvent>
  );
};

const propTypes = {
  onStartEdit: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  isEditMode: PropTypes.bool,
  isParent: PropTypes.bool,
  isTextPresent: PropTypes.bool,
};

const ParentTeacherWritePromptActions = ({
  onStartEdit,
  onCancel,
  onSave,
  isEditMode,
  isParent,
  isTextPresent,
}) => {
  const cancelOrSave = (
    <>
      <CancelButton onClick={onCancel} />
      <SaveButton onClick={onSave} disabled={!isTextPresent} />
    </>
  );
  return (
    <div>
      {!isParent && !isEditMode ? (
        <EditButton onClick={onStartEdit} />
      ) : (
        cancelOrSave
      )}
    </div>
  );
};

ParentTeacherWritePromptActions.propTypes = propTypes;

export default ParentTeacherWritePromptActions;
